module.exports = __webpack_public_path__ + "static/anim-673dd4d36ee920909b7ed34d8906925c.gif";